import Vue from 'vue'
import Config from '@/config'

let resource = null

export const actions = {
  // not use auth
  getPlayList: {
    method: 'GET',
    url: 'https://youtube.googleapis.com/youtube/v3/playlistItems',
    // auth: false,
    headers: {
      authorization: null,
    },
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}
const getPlayListVideoOnYoutube = async (id, params) => {
  const defaultOptions = {
    part: 'snippet',
    key: Config.youtubeAPIKey,
    maxResults: 50,
  }
  const res = await resource.getPlayList({ ...defaultOptions, ...params, playlistId: id })
  return res.body
}

export default {
  initResource,
  getPlayListVideoOnYoutube,
}
